import { DataSheet } from '@lune-fe/dapi-models'
import { InfiniteData, useInfiniteQuery } from 'react-query'

import { getDataSheets } from 'endpoints/dapi'
import { queryKeys } from 'queryKeys'

// TODO: Run the codegen script to update types once dapi is up to date
type PaginatedDataSheets = { hasMore: boolean; nextCursor: string | null; data: DataSheet[] }

const useDataSheets = (
    type: 'fintech' | 'logistics' | 'rfq' | 'logistics_user_template',
): {
    paginatedDataSheets: InfiniteData<PaginatedDataSheets> | undefined
    loading: boolean
    fetchNextPage: () => void
    refetch: () => void
    hasNextPage: boolean | undefined
} => {
    // The logistics_user_template page shows all logistic data sheets
    const cleanedType = type === 'logistics_user_template' ? 'logistics' : type
    const {
        data: paginatedDataSheets,
        isLoading,
        fetchNextPage,
        hasNextPage,
        refetch,
    } = useInfiniteQuery<PaginatedDataSheets>({
        queryKey: queryKeys.GET_DATA_SHEETS,
        queryFn: async ({ pageParam = { cursor: undefined } }) => {
            return getDataSheets({ after: pageParam.cursor }, cleanedType)
        },
        getNextPageParam: (lastPage) => {
            return lastPage.hasMore && lastPage.nextCursor
                ? { cursor: lastPage.nextCursor }
                : undefined
        },
        refetchOnMount: true,
    })

    return {
        paginatedDataSheets,
        loading: isLoading,
        fetchNextPage,
        refetch,
        hasNextPage,
    }
}

export default useDataSheets
